module.exports = __webpack_public_path__ + "img/logo-red.d432e692.svg";